import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { BiometricCatalogService, type BiometricReferenceRange, type BiometricReferenceRangeCreate, type BiometricReferenceRangeUpdate } from "@/lib/api_client";
import { getAuthHeaders } from "@/lib/api";
import { fetchAll } from "./fetchAll";

export const useReferenceRanges = () =>
  useQuery({
    queryKey: ["reference-ranges"],
    queryFn: () => fetchAll<BiometricReferenceRange>(BiometricCatalogService.getApiBiometricReferenceRanges),
    staleTime: 10 * 60_000,
  });

export const useCreateReferenceRange = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (data: BiometricReferenceRangeCreate) => {
      const res = await BiometricCatalogService.postApiBiometricReferenceRanges({ body: data, headers: getAuthHeaders() });
      if (!res.data) throw new Error("Failed");
      return res.data as unknown as BiometricReferenceRange;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["reference-ranges"] }),
  });
};

export const useUpdateReferenceRange = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: BiometricReferenceRangeUpdate }) => {
      const res = await BiometricCatalogService.putApiBiometricReferenceRangesById({ path: { id }, body: data, headers: getAuthHeaders() });
      if (!res.data) throw new Error("Failed");
      return res.data as unknown as BiometricReferenceRange;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["reference-ranges"] }),
  });
};

export const useDeleteReferenceRange = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await BiometricCatalogService.deleteApiBiometricReferenceRangesById({ path: { id }, headers: getAuthHeaders() });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["reference-ranges"] }),
  });
};
